import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import propertiesSectionData from "../data/propertiesSectionData";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";

export default function Properties() {
    const { t } = useTranslation();
    UseScrollAnimation();
    const uniqueCountries = [
        ...new Set(propertiesSectionData.map((el) => el.countries)),
    ];

    const [selectedCountry, setSelectedCountry] = useState(uniqueCountries[0]);

    const aggregatedPropertiesDetails = selectedCountry
        ? propertiesSectionData
            .filter((el) => el.countries === selectedCountry)
        : [];

    return (
        <>
            {/* Header Section */}
            <section className="contact-landing">
                <div className="container relative h-full flex flex-col items-center justify-center">
                    <div>
                        <h1 className="btmAni2000 font-bold text-white text-[40px] capitalize">
                            {t("Check out our featured properties")}
                        </h1>
                    </div>
                </div>
            </section>

            {/* Properties Filter Section */}
            <section className="relative py-[40px]">
                <div className="container">
                    {/* Country Filter Buttons */}
                    <div className="flex flex-wrap gap-2 mb-4">
                        {uniqueCountries.map((country) => (
                            <button
                                key={country}
                                onClick={() => setSelectedCountry(country)}
                                className={`px-4 py-2 border rounded ${selectedCountry === country ? "bg-[#B39359] capitalize font-bold py-[7px] px-[20px] text-white" : "bg-white text-[#B39359] py-[7px] px-[20px] font-bold capitalize"
                                    }`}
                            >
                                {t(country)}
                            </button>
                        ))}
                    </div>

                    {selectedCountry && (
                        <div className="flex flex-wrap gap-[10px]">
                            {aggregatedPropertiesDetails.length > 0 ? (
                                aggregatedPropertiesDetails.map((property, index) => (
                                    <div  key={index} className="js-scroll fade-top w-100 w-[31%] h-[500px] rounded-[8px] shadow-md">
                                        <Link to={`/landDetailes/${property.id}`} className="w-full h-[250px]">
                                            <img
                                                src={property.mainImage}
                                                alt={property.title}
                                                className="w-full h-[250px] rounded-t-[8px]"
                                            />
                                        </Link>
                                        <div className="p-[15px] h-[50%] flex flex-col justify-between gap-[10px]">

                                            <div className="h-full flex flex-col gap-[15px] justify-between">
                                                <div className="flex flex-col gap-[4px]">
                                                    <div className="font-bold text-[#0B2C3D]">{t(`${property.price}`)}</div>
                                                    <div className="font-bold text-[17px]">{t(`${property.title}`)}</div>
                                                    <div className="flex items-center gap-[5px]">
                                                        <img className="w-[15px] h-[15px]" src={require("../../assets/icons/prop-location.svg").default} alt="" />
                                                        <div>{t(`${property.countries}`)}, {t(`${property.city}`)}</div>
                                                    </div>
                                                </div>
                                                <div className="flex items-center gap-[10px]">
                                                    <div className="flex items-center gap-[5px]">
                                                        <img className="w-[20px] h-[20px]" src={require("../../assets/icons/bed.svg").default} alt="" />
                                                        <div>{t(`${property.bedroom}`)}</div>
                                                    </div>
                                                    |
                                                    <div className="flex items-center gap-[5px]">
                                                        <img className="w-[20px] h-[20px]" src={require("../../assets/icons/sqft.svg").default} alt="" />
                                                        <div>{t(`${property.area}`)}</div>
                                                    </div>
                                                </div>
                                                <div className="flex items-center justify-between gap-[7px]">
                                                    <Link className="flex items-center gap-[7px] p-2.5 px-4 bg-white shadow-md rounded border-[1px] border-[#0b2c3d]" to={"tel:+966 57 099 9395"}>
                                                        <img className="w-[20px] h-[20px]" src={require("../../assets/icons/phone-prop.svg").default} alt="" />
                                                        <div>{t("Call")}</div>
                                                    </Link>
                                                    <Link className="flex items-center gap-[7px] p-2.5 px-4 bg-white shadow-md rounded border-[1px] border-[#0b2c3d]" to={"mailto:info@ligasos.co"}>
                                                        <img className="w-[20px] h-[20px]" src={require("../../assets/icons/email-prop.svg").default} alt="" />
                                                        <div>{t("Emails")}</div>
                                                    </Link>
                                                    <Link className="flex items-center gap-[7px] p-2.5 px-4 bg-white shadow-md rounded border-[1px] border-[#0b2c3d]" to={"https://wa.link/544zck"}>
                                                        <img className="w-[20px] h-[20px]" src={require("../../assets/icons/whaats-prop.svg").default} alt="" />
                                                        <div>{t("Whatsapp")}</div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p>{t("No properties details available for this country.")}</p>
                            )}
                        </div>
                    )}
                </div>
            </section>
        </>
    )
}